import React,{useState,useEffect} from 'react';
import YouTube from 'react-youtube';
import axios from './axios';
import "./Row.css";
import movieTrailer from "movie-trailer";
//rfce to get a react function using es7 snippet in visual studio code

const baseUrl="https://image.tmdb.org/t/p/original/";

function Row({title,fetchUrl,isLargeRow}) {
    const [movies,setMovies]=useState([]);
    const [trailerUrl,setTrailerUrl]=useState("");
    
    //A snippet of code which runs based upon a specific conditions
    useEffect(() => {
        // if [], run once when the row loads and dont run again
        async function fetchData(){
            const request=await axios.get(fetchUrl);
            console.log(request);
            setMovies(request.data.results);
            return request;
        }

        fetchData();
    }, [fetchUrl]);
    
    const opts={
        height:"390",
        width:"100%",
        playerVars:{
            autoplay:1,
        }
    };

    const handleClick=(movie)=>{
        if(trailerUrl){
            setTrailerUrl('');
        }else{
            movieTrailer(movie?.name || "")
            .then(url=>{
                console.log(url);
                const urlParams=new URLSearchParams(new URL(url).search);
                setTrailerUrl(urlParams.get("v"));
            })
            .catch(error=>{
                console.log(error);
            });
        }
    };

    console.log(movies);
    return (
        <div className="row">
            <h1 className="title">{title}</h1>
            <div className="row__posters">
                {movies.map(movie=>(
                    <img 
                    onClick={()=>handleClick(movie)}
                    key={movie.id}
                    className={`row__poster ${isLargeRow && "row_poster_large"}`} src={`${baseUrl}${
                        isLargeRow? movie.poster_path: movie.backdrop_path}`} alt={movie.name}/>
                ))}
            </div>
            <div className="youtube">
                { trailerUrl && <YouTube videoId={trailerUrl} opts={opts}/>}
            </div>
        </div> 
    )
}

export default Row;
